import { render, staticRenderFns } from "./options-question.vue?vue&type=template&id=9b1127fe&"
import script from "./options-question.vue?vue&type=script&lang=js&"
export * from "./options-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b1127fe')) {
      api.createRecord('9b1127fe', component.options)
    } else {
      api.reload('9b1127fe', component.options)
    }
    module.hot.accept("./options-question.vue?vue&type=template&id=9b1127fe&", function () {
      api.rerender('9b1127fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/options-question.vue"
export default component.exports